<div class="container">
  <div class="head">
    {{ 'MENU.SCHEDULES' | translate }}
  </div>
  <div class="table-container mat-elevation-z8">
    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows>

      <ng-container
        *ngFor="let column of columnsToDisplay"
        matColumnDef="{{ column }}">
        <th mat-header-cell *matHeaderCellDef [ngSwitch]="column">
          <ng-template ngSwitchDefault>
            <div>{{ getColumnHeaderName(column) }}</div>
          </ng-template>
        </th>
        <td
          mat-cell *matCellDef="let element">
          <div class="wrap-cell" [ngSwitch]="column">
            <div class="cell">
              <ng-template ngSwitchCase="dayOfWeek">
                <mat-label>{{element.dayOfWeek | weekPipe}}</mat-label>
              </ng-template>
              <ng-template ngSwitchCase="isActiveMenuSchedule">
                <mat-checkbox
                  [disabled]="true"
                  [checked]="element.isActiveMenuSchedule"
                  type="checkbox">
                </mat-checkbox>
              </ng-template>
              <ng-template ngSwitchCase="isActiveEntitySchedule">
                <mat-checkbox
                  [checked]="element.isActiveEntitySchedule"
                  (change)="changeIsActive(element.menuScheduleId, $event.checked)"
                  type="checkbox">
                </mat-checkbox>
              </ng-template>
              <ng-template ngSwitchDefault>
                <div>{{ element[column] }}</div>
              </ng-template>
            </div>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="columnsToDisplay; sticky: true">
      </tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay">
      </tr>
    </table>
  </div>
  <div class="buttons">
    <button mat-button color="primary" [disabled]="!hasChanges()"
            (click)="saveAllAsync()">
      {{'COMMON.SAVE'|translate}}
    </button>

    <button mat-button color="warn" (click)="exit()">
      {{ "COMMON.CANCEL" | translate }}
    </button>
  </div>
</div>
